<template>
  <grid-layout
    :layout.sync="widgets"
    :col-num="2"
    :row-height="80"
    :is-draggable="true"
    :is-mirrored="false"
    :is-resizable="true"
    :vertical-compact="false"
    :margin="[10, 10]"
    :use-css-transforms="true"
  >
    <grid-item
      v-for="(widget, i) in widgets"
      class="widget"
      :max-w="getDimensionsForResourcetype(widget.resourcetype).MAX_COLS"
      :max-h="getDimensionsForResourcetype(widget.resourcetype).MAX_ROWS"
      :min-w="getDimensionsForResourcetype(widget.resourcetype).MIN_COLS"
      :min-h="getDimensionsForResourcetype(widget.resourcetype).MIN_ROWS"
      :x="widget.x"
      :y="widget.y"
      :w="widget.w"
      dragIgnoreFrom=".remove-widget,.edit-widget"
      :h="widget.h"
      :i="widget.i"
      :key="widget.i"
    >
      <div
        class="widget-header"
        :class="{
          'widget-header--has-errors':
            errors[i] && Object.keys(errors[i]).length > 0
        }"
      >
        <div class="widget-header__title">
          {{ getWidgetTypeLabel(widget.resourcetype) }}
        </div>
        <div class="widget-header__buttons">
          <el-button
            class="edit-widget"
            @click.stop="$emit('editWidget', i)"
            circle
            type="warning"
            size="mini"
            icon="el-icon-edit"
          />
          <el-button
            class="remove-widget"
            @click.stop="$emit('removeWidget', i)"
            circle
            type="danger"
            size="mini"
            icon="el-icon-delete"
          />
        </div>
      </div>
    </grid-item>
  </grid-layout>
</template>
<script>
import VueGridLayout from 'vue-grid-layout'

export default {
  props: {
    widgets: Array,
    errors: [Array, String]
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  computed: {
    nonFieldErrors() {
      const isString = typeof this.errors === 'string'
      return isString && this.errors
    },
    getWidgetType() {
      return this.$store.getters.getWidgetByResourcetype
    }
  },
  methods: {
    editWidget(widgetIndex) {
      this.$refs.widgetDialogs.editWidget(widgetIndex)
    },
    getWidgetTypeLabel(resourcetype) {
      const widgetType = this.getWidgetType(resourcetype)
      const label = widgetType && widgetType.label
      return label || resourcetype
    },
    getDimensionsForResourcetype(resourcetype) {
      const widgetType = this.getWidgetType(resourcetype)
      return widgetType && widgetType.dimensions
    }
  }
}
</script>
<style lang="scss" scoped>
.widget {
  padding: 15px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  cursor: pointer;
  position: relative;

  &:hover {
    background: #f3f3f3;
  }

  &-header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-size: 24px;
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 300;
    }
  }
}
</style>
